/** Origem de uma alteração na trilha de auditoria (histórico do indicador e do objetivo). */
export const AUDIT_SOURCE_LABELS: Record<string, string> = {
  SCREEN: 'Tela',
  IMPORT: 'Importação',
  CALCULATION: 'Cálculo automático',
  JOB: 'Rotina automática',
};
